/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Color } from 'csstype'
import { Fragment } from 'react'
import { CidadaoListagemDiabetesQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel'
import { AcompanhamentoCondicaoSaudeExamesAccordionPanel } from './AcompanhamentoCondicaoSaudeExamesAccordionPanel'

interface AcompanhamentoCondicaoSaudeDiabetesAccordionSectionProps {
  row: Readonly<CidadaoListagemDiabetesQueryModel>
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDiabetesAccordionSection({
  row,
  iconColor,
}: AcompanhamentoCondicaoSaudeDiabetesAccordionSectionProps) {
  return (
    <Fragment>
      <AcompanhamentoCondicaoSaudeExamesAccordionPanel
        exames={row?.cidadao?.cidadaoConsolidado?.diabetes?.exames}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel
        dataUltimasVisitasDomiciliares={
          row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
        }
        qtdVisitasDomiciliares={row?.cidadao?.cidadaoConsolidado.visitaDomiciliar?.qtdVisitasDomiciliares}
        iconColor={iconColor}
      />
    </Fragment>
  )
}
